import { Controller, Payload } from "../../config/controller";
import store, { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { Sala, initialValueSalaState, SalaState, SalaActions } from "./sala.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { StatusAppState } from "../root/root.model";

export interface SalaViewProps {
    salaState: SalaState
    salaActions: SalaActions
}


class SalaController extends Controller<Sala, SalaState, SalaActions> {
    constructor() {
        super(initialValueSalaState.row.type, initialValueSalaState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects

        ]
    }



    private * salaReadAllEffects(actions: Payload) {

    }
}

export const salaController = new SalaController()

export const mapStateToSalaProps = (state: ApplicationState) => ({
    salaState: state.salaState,
})

export const mapDispatchToSalaProps = (dispatch: Dispatch) => ({
    salaActions: bindActionCreators({ ...salaController.reducer.actions }, dispatch),
})

export const handleSelecionarSala = (set:boolean) => {
    store.dispatch(salaController.reducer.actions.setShowSelectModal(set));
    if(salaController.state.rows.length === 0)
        store.dispatch(salaController.reducer.actions.read())
}